export default "__VITE_PUBLIC_ASSET__a08c2af3__"